// "Добавьте Humanteq на главный экран" overlay — shown once right after
// registration (via useOnboardingGate / Onboarding's complete()) and again
// after a successful payment if the PWA still isn't installed
// (usePaymentSuccess). Mobile-only, gated in installGuideStore.requestShow().

import { useState } from 'react'
import { useInstallGuideStore } from '../store/installGuideStore'
import { isNative } from '../lib/platform'
import DeviceMockup from '../screens/Install/DeviceMockup'
import styles from './InstallGuidePrompt.module.css'

const STEPS = {
  ios: [
    'Нажмите «Поделиться» ⎋ внизу экрана',
    'Пролистайте и выберите «На экран „Домой“»',
    'Нажмите «Добавить» — иконка появится на экране',
  ],
  android: [
    'Нажмите ⋮ в правом верхнем углу',
    'Выберите «Установить приложение» или «Добавить на главный экран»',
    'Подтвердите — иконка появится на экране',
  ],
}

export default function InstallGuidePrompt() {
  const open = useInstallGuideStore((s) => s.open)
  const close = useInstallGuideStore((s) => s.close)
  const [os, setOs] = useState<'ios' | 'android'>('ios')

  // Внутри Capacitor приложение уже установлено: инструкция «нажмите ⋮ →
  // Установить приложение» здесь бессмысленна. Тот же гард, что в InstallPrompt.
  if (isNative || !open) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <button className={styles.closeX} onClick={close} aria-label="Закрыть">✕</button>

        <div className={styles.scrollArea}>
          <h3>Добавьте Humanteq на главный экран</h3>
          <p>
            Чтобы возвращаться к работе без поиска ссылки и лишних вкладок, работает как обычное
            приложение. Займёт 5 секунд.
          </p>

          <div className={styles.osTabs}>
            <button className={`${styles.osTab} ${os === 'ios' ? styles.osActive : ''}`} onClick={() => setOs('ios')}>
              iOS
            </button>
            <button
              className={`${styles.osTab} ${os === 'android' ? styles.osActive : ''}`}
              onClick={() => setOs('android')}
            >
              Android
            </button>
          </div>

          <DeviceMockup
            os={os}
            caption={
              <ol className={styles.steps}>
                {STEPS[os].map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>
            }
          />
        </div>

        <div className={styles.actions}>
          <button className={styles.primaryBtn} onClick={close}>Понятно</button>
        </div>
      </div>
    </div>
  )
}
